import { Component, HostBinding, HostListener, Input, OnInit, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { HubConnectionState } from '@microsoft/signalr';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import * as Sentry from '@sentry/angular';
import { take } from 'rxjs';
import Info from '../../models/info.model';
import { CoreService } from '../../services/core.service';
import { StatusBarService } from '../../services/status-bar.service';

@UntilDestroy()
@Component({
  selector: 'app-status-bar',
  templateUrl: './status-bar.component.html',
  styleUrls: ['./status-bar.component.less'],
})
export class StatusBarComponent implements OnInit {
  @Input() autoHide = false;
  @HostBinding('class.auto-hide') get isAutoHide() {
    return this.autoHide;
  }
  @HostBinding('class.hovered') isHovered = false;

  isOnline = true;
  hubState: HubConnectionState = HubConnectionState.Disconnected;
  serverInfo = toSignal(this.coreService.serverInfo$);
  versionInfoModalVisible = signal(false);
  info?: Info;

  @HostListener('window:online', ['$event'])
  @HostListener('window:offline', ['$event'])
  onNetworkChange(event: Event) {
    if (event.type === 'offline') {
      this.isOnline = false;
    }
    if (event.type === 'online') {
      this.isOnline = true;
    }
  }

  constructor(
    private readonly statusBarService: StatusBarService,
    private readonly coreService: CoreService
  ) {}

  ngOnInit(): void {
    this.statusBarService.state$.pipe(untilDestroyed(this)).subscribe((state) => {
      this.hubState = state;
    });

    this.coreService
      .getInfo$()
      .pipe(take(1), untilDestroyed(this))
      .subscribe((info) => {
        this.info = info;
        this.statusBarService.setInfo(info);
        Sentry.setContext('Server', { backendVersion: info.appVersion });
      });
  }

  openVersionInfo() {
    this.versionInfoModalVisible.set(true);
  }
}
